import { MouseEventHandler } from "react";
import { Button, Typography } from "@bca/ui-library";

const CloseButton: React.FunctionComponent<{
  onClick: MouseEventHandler<HTMLButtonElement>;
}> = ({ onClick }) => {
  return (
    <Button onClick={onClick} variant="tertiary" m={0} p={0} height={16}>
      <Typography
        m={0}
        p={0}
        color="primary"
        fontWeight="light"
        fontSize="40px"
        lineHeight="20px"
      >
        &times;
      </Typography>
    </Button>
  );
};

export default CloseButton;
